import React from "react";

import { Button } from "../../Button/Button";
import { Modal } from "../Modal/Modal";
import type { ModalSize } from "../Modal/Modal.types";

type InfoModalProps = {
    isOpen: boolean;
    onClose: () => void;
    size?: ModalSize;
    disableAutofocus?: boolean;
};

export const InfoModal: React.FC<React.PropsWithChildren<InfoModalProps>> = ({
    isOpen,
    onClose,
    size,
    disableAutofocus,
    children,
}) => {
    return (
        <Modal size={size} isOpen={isOpen} onClose={onClose} disableAutofocus={disableAutofocus}>
            {children}

            <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                <Button onClick={onClose}>Close</Button>
            </div>
        </Modal>
    );
};
